<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2 v-if="!isAdminEmpreinte">Consulter ou modifier les formulaires d'empreinte soumis</h2>
        <h2 v-if="isAdminEmpreinte">Consulter les formulaires d'empreinte</h2>

        <b-col cols="10">
            <b-row>
                <b-col cols="4">
                    <b-form-group id="input-group-marches"
                                  :label=libelles.marche label-for="input-marcheIds"
                                  v-if="isAdmin">
                        <AutocompleteCustom
                                id="input-marcheIds"
                                :items="marcheIdsItems"
                                v-model="marcheId"
                                @search="onMarcheSearch"
                                :placeholder=libelles.selectionnerMarche
                                :clear=ligneId
                        >
                        </AutocompleteCustom>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group id="input-group-lignes"
                                  :label=libelles.ligne label-for="input-lignes"
                                  v-if="isAdmin">
                        <b-form-select
                                id="input-lignes"
                                v-model="ligneId"
                                :options="lignes"
                                required>
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                    {{libelles.selectionnerLigne}}
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col cols="1" offset="3">
                    <b-button v-if="marcheId || ligneId" type="button" variant="success" @click="exporter">Exporter
                    </b-button>
                </b-col>
            </b-row>

            <b-card header="Filtres de recherche" class="mb-3 mt-3">
                <b-row>
                    <b-col>
                        <b-form-group
                                :label=empreinteEco.libelleEntrepriseSiret
                                id="input-group-siretEntreprise"
                                label-for="input-siretEntreprise">
                            <b-form-input
                                    id="input-group-siretEntreprise"
                                    v-model="siretEntreprise"
                                    type="text"
                                    @input="onFilterChange"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                                :label=empreinteEco.libelleEntrepriseNom
                                id="input-group-nomEntreprise"
                                label-for="input-nomEntreprise">
                            <b-form-input
                                    id="input-group-nomEntreprise"
                                    v-model="nomEntreprise"
                                    type="text"
                                    @input="onFilterChange"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group
                                label="Objet de la prestation"
                                id="input-group-objetPrestation"
                                label-for="input-objetPrestation">
                            <b-form-input
                                    id="input-group-objetPrestation"
                                    v-model="objetPrestation"
                                    type="text"
                                    @input="onFilterChange"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="4">
                        <b-form-group id="input-group-statuts"
                                      :label=libelles.statut label-for="input-statuts">
                            <b-form-select
                                    id="input-statuts"
                                    v-model="statuts"
                                    @change="search">
                                <b-form-select-option
                                        :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION']">
                                    Valides et en attente
                                </b-form-select-option>
                                <b-form-select-option :value="['SUPPRIMEE', 'ARCHIVEE', 'REFUSE']">
                                    Archivés
                                </b-form-select-option>
                                <b-form-select-option
                                        :value="['VALIDE', 'ATTENTE_MODIFICATION', 'ATTENTE_SUPPRESSION', 'SUPPRIMEE', 'ARCHIVEE', 'REFUSE']">
                                    Tous
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>

        </b-col>

        <div v-if="empreintesResult">
            <div class="overflow-auto">
                <b-row class="align-content-center">
                    <b-col cols="2">
                        <b-form-select
                                v-model="pageSize"
                                :options="pageSizes"
                                @change="search()"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="4" offset="1">
                        <b-pagination
                                v-model="pageIndex"
                                :total-rows="empreintesResult.totalElements"
                                :per-page="pageSize"
                                :limit="10"
                                align="center"
                                @input="search()"
                        ></b-pagination>
                    </b-col>
                </b-row>
                <b-table striped hover
                         :per-page="pageSize"
                         :no-local-sorting="true"
                         @sort-changed="sort"
                         :items="empreintesTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{pageSize * (pageIndex - 1) + (row.index + 1)}}
                        </div>
                    </template>
                    <template v-slot:cell(objetPrestation)="row">
                        <div v-b-tooltip.hover
                             :title="row.value">
                            {{truncate(row.value)}}
                        </div>
                    </template>
                    <template v-slot:cell(cheminFichierJustificatif)="row">
                        <JustificatifButton :url="ENDPOINT_EMPREINTE_ECONOMIQUE_PIECE_JUSTIFICATIF" :row="row" />
                    </template>
                    <template v-slot:cell(edit)="row">
                        <b-button size="sm" @click="consulterEmpreinte(row.item.id)"
                                  v-if="row.item.statut !== 'VALIDE' || isRead">
                            <Icon icon="book-open" size="1x"></Icon>
                        </b-button>
                        <b-button size="sm" @click="consulterEmpreinte(row.item.id)"
                                  v-if="row.item.statut === 'VALIDE' && (!row.item.jourSoumissionPassed || isAdminEmpreinte) && !isRead">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                        <b-button size="sm"
                                  v-if="row.item.statut === 'VALIDE' && row.item.jourSoumissionPassed && !isAdminEmpreinte && !isRead"
                                  v-b-modal="'modal-edit' + row.item.id">
                            <Icon icon="edit" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-edit' + row.item.id"
                                title="Modification de formulaire d'empreinte"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="consulterEmpreinte(row.item.id)">
                            <p>{{libelles.messageHorsPeriodeSoumission}}</p>
                        </b-modal>
                    </template>
                    <template v-slot:cell(delete)="row">
                        <b-button size="sm" v-b-modal="'modal-delete' + row.item.id"
                                  v-if="row.item.statut !== 'ATTENTE_SUPPRESSION' && row.item.statut !== 'SUPPRIMEE' && row.item.statut !== 'ARCHIVEE'">
                            <Icon icon="trash" size="1x"></Icon>
                        </b-button>
                        <b-modal
                                :id="'modal-delete' + row.item.id"
                                title="Suppression de formulaire d'empreinte"
                                ok-title="Confirmer"
                                cancel-title="Annuler"
                                @ok="supprimerEmpreinte(row.item)">
                            <p>Confirmez-vous la suppression de ce formulaire d'empreinte ?</p>
                            <p v-if="row.item.statut === 'VALIDE'">
                                La suppression de ce formulaire entrainera la suppression des modifications en attente
                                associées.
                            </p>
                            <p v-if="row.item.jourSoumissionPassed && !isAdminEmpreinte && row.item.statut === 'VALIDE'">
                                {{libelles.messageHorsPeriodeSoumission}}
                            </p>
                        </b-modal>
                    </template>
                </b-table>
            </div>
        </div>

    </div>
</template>

<script>

  import EmpreinteEconomiqueStore from "../../stores/EmpreinteEconomiqueStore";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import LigneStore from "../../stores/LigneStore";
  import SessionStore from '@/stores/SessionStore'
  import hasPermission from "../../filters/hasPermission";
  import FileUtil from "../../utils/fileUtil";
  import {EventBus} from '@/event-bus'
  import {StatutEnum} from "../../constants/enums";
  import moment from 'moment';
  import EmpreinteEconomiqueDto from "../../dtos/EmpreinteEconomiqueDto";
  import _ from 'lodash';
  import {truncate} from "../../utils/stringUtil";
  import {libelles, empreinteEco} from '../../constants/libelles';
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import {ENDPOINT_EMPREINTE_ECONOMIQUE_PIECE_JUSTIFICATIF} from "../../constants/endpoints";
  import JustificatifButton from "@/components/utils/JustificatifButton.vue";

  export default {
    components: {
        JustificatifButton,
      AutocompleteCustom,
    },
    data() {
      return {
        sessionStoreState: SessionStore.state,
        marcheId: null,
        ligneId: null,
        marches: [],
        lignes: [],
        statuts: ['VALIDE', 'ATTENTE_MODIFICATION', 'ARCHIVEE', 'ATTENTE_SUPPRESSION'],
        empreintesResult: null,
        pageSize: null,
        pageSizes: [10, 25, 50, 100],
        pageIndex: null,
        sortOptions: null,
        siretEntreprise: null,
        nomEntreprise: null,
        objetPrestation: null,
        libelles: libelles,
        empreinteEco: empreinteEco,
        marcheIdsItems: [],
        ENDPOINT_EMPREINTE_ECONOMIQUE_PIECE_JUSTIFICATIF
      }
    },
    computed: {
      isAdminEmpreinte() {
        return hasPermission(["ADMINISTRATEUR", "CORRESPONDANT_EMPREINTE_ADMINISTRATEUR"]);
      },
      isAdmin() {
        return this.isAdminEmpreinte && !this.sessionStoreState.marches.length;
      },
      isRead() {
        return hasPermission(['CORRESPONDANT_EMPREINTE_LECTURE'])
      },
      fields() {
        const fields = [
          {label: '', key: 'num', sortable: false},
          {label: 'Date de dernière modification', key: 'modifiedDate', sortable: true},
          {label: 'Données pour le mois', key: 'date', sortable: true},
          {label: 'Entreprise SIRET', key: 'siretEntreprise', sortable: true},
          {label: 'Entreprise nom', key: 'nomEntreprise', sortable: true},
          {label: 'Objet de la prestation', key: 'objetPrestation', sortable: true},
          {label: 'PME', key: 'pme', sortable: false},
          {label: 'Statut', key: 'statutLabel', sortable: false},
          {label: 'Consulter / Modifier', key: 'edit', sortable: false},
          {label: 'Supprimer', key: 'delete', sortable: false},
          {label: 'Piece Justificative', key: 'cheminFichierJustificatif', sortable: false}
        ];
        if (this.isAdmin) {
          fields.splice(1, 0, {label: 'Marché', key: 'referenceMarche', sortable: true})
        }
        if (this.isRead) {
          fields.splice(fields.length - 1, 1)
        }
        return fields;
      },
      empreintesTable: function () {
        return this.empreintesResult.content.map(empreinte => {
          return {
            id: empreinte.id,
            modifiedDate: new Date(empreinte.modifiedDate).toLocaleDateString(),
            date: moment(empreinte.date).format('MM/YYYY'),
            referenceMarche: empreinte.referenceMarche,
            siretEntreprise: empreinte.siretEntreprise,
            nomEntreprise: empreinte.nomEntreprise,
            objetPrestation: empreinte.objetPrestation,
            pme: empreinte.pme ? 'Oui' : 'Non',
            statut: empreinte.statut,
            statutLabel: StatutEnum[empreinte.statut],
            jourSoumissionPassed: empreinte.jourSoumissionPassed,
            cheminFichierJustificatif: empreinte.cheminFichierJustificatif
          }
        });
      }
    },
    watch: {
      marcheId(newMarcheId) {
        this.onMarcheSearch(newMarcheId, true);
        this.search();
      },
      ligneId(newLigneId) {
        if (newLigneId) {
          this.marcheId = null;
        }
        this.onMarcheSearch();
        this.search();
      },
    },
    mounted() {
      this.initPagination();
      if (this.isAdmin) {
        MarcheStore.getAll().then(marches => {
          this.marches = marches.map(marche => {
            return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
          });
          this.marcheIdsItems = this.marches;
        });
        LigneStore.getAll().then(
            response => this.lignes = response.map(value => {
              return {text: value.libelleLong, value: value.id};
            })
        );
        this.search();
      } else {
        this.marcheId = this.sessionStoreState.marche.id;
        EventBus.$on('NavBar-marcheChange', () => {
          this.marcheId = this.sessionStoreState.marche.id;
          this.search();
        });
      }
    },
    beforeDestroy() {
      if (!this.isAdmin) {
        EventBus.$off('NavBar-marcheChange');
      }
    },
    methods: {
      truncate(value) {
        return truncate(value, 50);
      },
      initPagination() {
        this.pageSize = 10;
        this.pageIndex = 1;
        this.sortOptions = [{sortBy: 'modifiedDate', sortDirection: 'desc'}];
      },
      onFilterChange: _.debounce(function () {
        this.search();
      }, 1000),
      sort(sort) {
        this.sortOptions = [{sortBy: sort.sortBy, sortDirection: sort.sortDesc ? 'desc' : 'asc'}];
        this.search();
      },
      consulterEmpreinte(id) {
        this.$router.push("/empreinte-economique/" + id);
      },
      supprimerEmpreinte(empreinte) {
        EmpreinteEconomiqueStore.delete(empreinte).then(() => {
          this.search();
        });
      },
      search() {
        const empreinte = this.createEmpreinteRecherche();
        EmpreinteEconomiqueStore.search(empreinte, this.pageIndex - 1, this.pageSize, this.sortOptions).then(
            result => {
              this.empreintesResult = result.data;
            },
            error => AlertStore.pushError(error.response.data.message)
        )
      },
      exporter() {
        if (this.marcheId || this.ligneId) {
          const empreinte = this.createEmpreinteRecherche();
          EmpreinteEconomiqueStore.export(empreinte).then(
              result => {
                FileUtil.downloadFile(result.data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf8;');
              },
              error => AlertStore.pushError(error.response.data.message)
          )
        }
      },
      createEmpreinteRecherche() {
        const empreinte = new EmpreinteEconomiqueDto();
        empreinte.marcheId = this.marcheId;
        empreinte.ligneId = this.ligneId;
        empreinte.statut = this.statuts;
        empreinte.siretEntreprise = this.siretEntreprise && this.siretEntreprise !== '' ? this.siretEntreprise : null;
        empreinte.nomEntreprise = this.nomEntreprise && this.nomEntreprise !== '' ? this.nomEntreprise : null;
        empreinte.objetPrestation = this.objetPrestation && this.objetPrestation !== '' ? this.objetPrestation : null;
        return empreinte;
      },
      onMarcheSearch(marche, isId) {
        if (marche) {
          this.ligneId = null;
        }
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marches)
      }
    }
  }
</script>

